(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["file-upload"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.customLogoUploadInitialized) return;
    window.customLogoUploadInitialized = true;

    const allowedExtensions = ['png', 'jpg', 'jpeg', 'svg', 'pdf'];
    const maxFiles = 2;
    const selections = new WeakMap();
    const getProduct = (element) => element.closest('[data-section-type="product"]');
    const getWrapper = (element) => element.closest('[data-custom-logo-upload]');
    const getFiles = (wrapper) => selections.get(wrapper) || [];

    const getTargets = (input) => {
      const product = getProduct(input);
      const key = input.dataset.logoUploadInput;
      if (!product) return [];
      return [1, 2]
        .map((index) => product.querySelector(`[data-logo-upload-target="${CSS.escape(key)}-${index}"]`))
        .filter(Boolean);
    };

    const setInputFiles = (input, files) => {
      const transfer = new DataTransfer();
      files.forEach((file) => transfer.items.add(file));
      input.files = transfer.files;
    };

    const syncTargets = (input, files) => {
      getTargets(input).forEach((target, index) => {
        if (files[index]) {
          setInputFiles(target, [files[index]]);
        } else {
          target.value = '';
        }
      });
    };

    const syncAllFiles = (wrapper) => {
      const input = wrapper.querySelector('[data-logo-upload-input]');
      if (input) syncTargets(input, getFiles(wrapper));
    };

    const extensionFor = (file) => file.name.split('.').pop().toLowerCase();
    const isAllowed = (file) => allowedExtensions.includes(extensionFor(file));
    const fileKey = (file) => `${file.name}:${file.size}:${file.lastModified}`;

    const clearObjectUrls = (wrapper) => {
      wrapper.querySelectorAll('[data-upload-preview][data-object-url]').forEach((preview) => {
        URL.revokeObjectURL(preview.dataset.objectUrl);
      });
    };

    const setError = (wrapper, message) => {
      const error = wrapper.querySelector('[data-upload-error]');
      error.textContent = message;
      error.classList.toggle('hidden', !message);
    };

    const uploadIsComplete = (wrapper) => getFiles(wrapper).length > 0;

    const updateProductState = (wrapper) => {
      const product = getProduct(wrapper);
      if (!product) return;
      const complete = uploadIsComplete(wrapper);
      product.toggleAttribute('data-logo-upload-incomplete', !complete);
      product.toggleAttribute('data-has-logo-upload', true);
      if (complete) setError(wrapper, '');
    };

    const renderSelections = (wrapper) => {
      const results = wrapper.querySelector('[data-upload-results]');
      const template = wrapper.querySelector('[data-upload-result-template]');
      clearObjectUrls(wrapper);
      results.replaceChildren();

      getFiles(wrapper).forEach((file, index) => {
        const result = template.content.firstElementChild.cloneNode(true);
        const preview = result.querySelector('[data-upload-preview]');
        const status = result.querySelector('[data-upload-status]');
        const removeButton = result.querySelector('[data-upload-remove]');
        const isPdf = extensionFor(file) === 'pdf';

        removeButton.dataset.uploadIndex = index;
        if (isPdf) {
          status.textContent = wrapper.dataset.pdfMessage.replace('[filename]', file.name);
        } else {
          const objectUrl = URL.createObjectURL(file);
          preview.src = objectUrl;
          preview.dataset.objectUrl = objectUrl;
          preview.alt = file.name;
          preview.classList.remove('hidden');
          status.textContent = wrapper.dataset.imageMessage.replace('[filename]', file.name);
        }

        results.append(result);
      });
    };

    const saveFiles = (input, files) => {
      const wrapper = getWrapper(input);
      selections.set(wrapper, files);
      setInputFiles(input, files);
      syncTargets(input, files);
      renderSelections(wrapper);
      updateProductState(wrapper);
    };

    const addFiles = (input, incomingFiles) => {
      const wrapper = getWrapper(input);
      const existingFiles = getFiles(wrapper);
      const existingKeys = new Set(existingFiles.map(fileKey));
      const uniqueIncoming = Array.from(incomingFiles).filter((file) => !existingKeys.has(fileKey(file)));
      const combinedFiles = existingFiles.concat(uniqueIncoming);

      if (uniqueIncoming.some((file) => !isAllowed(file))) {
        setInputFiles(input, existingFiles);
        setError(wrapper, wrapper.dataset.invalidMessage);
        input.focus();
        return;
      }

      if (combinedFiles.length > maxFiles) {
        setInputFiles(input, existingFiles);
        setError(wrapper, wrapper.dataset.maxFilesMessage);
        input.focus();
        return;
      }

      saveFiles(input, combinedFiles);
    };

    const removeFile = (button) => {
      const wrapper = getWrapper(button);
      const input = wrapper.querySelector('[data-logo-upload-input]');
      const removeIndex = Number(button.dataset.uploadIndex);
      const remainingFiles = getFiles(wrapper).filter((file, index) => index !== removeIndex);
      saveFiles(input, remainingFiles);
    };

    const showRequiredError = (wrapper) => {
      const input = wrapper.querySelector('[data-logo-upload-input]');
      setError(wrapper, wrapper.dataset.requiredMessage);
      if (input) input.focus();
      wrapper.scrollIntoView({ behavior: 'smooth', block: 'center' });
    };

    const addToCartWithFiles = async (form, wrapper) => {
      const product = getProduct(form);
      const buttons = Array.from(product.querySelectorAll('[data-add-to-cart]'));
      buttons.forEach((button) => {
        button.disabled = true;
        button.classList.add('loading');
      });

      try {
        const route = window.theme?.routes?.cart?.add || form.action;
        const endpoint = route.endsWith('.js') ? route : `${route}.js`;
        const response = await fetch(endpoint, {
          method: 'POST',
          credentials: 'include',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: new FormData(form)
        });
        const result = await response.json();
        if (!response.ok || result.status === 422) {
          throw new Error(result.description || result.message || wrapper.dataset.uploadErrorMessage);
        }
        window.location.assign(window.theme?.routes?.cart?.base || '/cart');
      } catch (error) {
        setError(wrapper, error.message || wrapper.dataset.uploadErrorMessage);
        buttons.forEach((button) => {
          button.disabled = false;
          button.classList.remove('loading');
        });
      }
    };

    document.addEventListener('change', (event) => {
      const input = event.target.closest('[data-logo-upload-input]');
      if (input) addFiles(input, input.files);
    });

    document.addEventListener('click', (event) => {
      const removeButton = event.target.closest('[data-upload-remove]');
      if (removeButton) {
        removeFile(removeButton);
        return;
      }

      const addButton = event.target.closest('[data-add-to-cart]');
      if (!addButton) return;
      const product = getProduct(addButton);
      const wrapper = product ? product.querySelector('[data-custom-logo-upload]') : null;
      if (wrapper && !uploadIsComplete(wrapper)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        showRequiredError(wrapper);
      }
    }, true);

    document.addEventListener('dragover', (event) => {
      const dropzone = event.target.closest('[data-upload-dropzone]');
      if (!dropzone) return;
      event.preventDefault();
      dropzone.dataset.dragActive = 'true';
    });

    document.addEventListener('dragleave', (event) => {
      const dropzone = event.target.closest('[data-upload-dropzone]');
      if (dropzone) dropzone.dataset.dragActive = 'false';
    });

    document.addEventListener('drop', (event) => {
      const dropzone = event.target.closest('[data-upload-dropzone]');
      if (!dropzone) return;
      event.preventDefault();
      dropzone.dataset.dragActive = 'false';
      const input = dropzone.parentElement.querySelector('[data-logo-upload-input]');
      if (input) addFiles(input, event.dataTransfer.files);
    });

    document.addEventListener('submit', (event) => {
      const form = event.target.closest('[data-product-form]');
      if (!form) return;
      const product = getProduct(form);
      const wrapper = product ? product.querySelector('[data-custom-logo-upload]') : null;
      if (!wrapper) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      if (!uploadIsComplete(wrapper)) {
        showRequiredError(wrapper);
        return;
      }

      syncAllFiles(wrapper);
      addToCartWithFiles(form, wrapper);
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
